"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateComponentLink = generateComponentLink;
function generateComponentLink(item) {
    if (!item)
        return "";
    const toLink = (name) => `[${name}](/:handle/:documentSlug?fit=${encodeURIComponent(name)})`;
    return item
        .split(",")
        .map((v) => toLink(v.trim()))
        .join(", ");
}
//# sourceMappingURL=generateComponentLink.js.map